import { c as _c } from "react/compiler-runtime";
import { useAnalytics } from '@repo/analytics/analytics-provider';
import { useHostType } from '@repo/host/hooks/use-host-info';
import { useAppDispatch, useAppSelector } from '@repo/store/maps/hooks';
import { setActiveCategoryId } from '@repo/store/maps/slices/clientContext';
import { type FilterState, selectCurrentMapInfo, selectExternalMapId, selectFilterState, selectMapData, selectTitleName, setFilterStateFromUrl } from '@repo/store/maps/slices/mapData';
import { useCallback, useMemo, useRef } from 'react';
import { buildCategoryMap, isIncludedInChecklist } from './checklist-utils';
export function useChecklistNavigation() {
  const $ = _c(31);
  const dispatch = useAppDispatch();
  const mapData = useAppSelector(selectMapData);
  const filters = useAppSelector(selectFilterState);
  const savedFiltersRef = useRef(null);
  const analytics = useAnalytics();
  const hostType = useHostType();
  const externalMapId = useAppSelector(selectExternalMapId);
  const currentMapInfo = useAppSelector(selectCurrentMapInfo);
  const titleName = useAppSelector(selectTitleName);
  let t0;
  bb0: {
    if (!mapData) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new Set();
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    let ids;
    if ($[1] !== mapData) {
      const catMap = buildCategoryMap(mapData);
      ids = new Set();
      for (const sub of mapData.metadata.subcategories) {
        const cat = catMap.get(sub.categoryExternalId);
        if (cat && isIncludedInChecklist(sub, cat)) {
          ids.add(sub.externalId);
        }
      }
      $[1] = mapData;
      $[2] = ids;
    } else {
      ids = $[2];
    }
    t0 = ids;
  }
  const checklistSubcategoryIds = t0;
  let t1;
  bb1: {
    if (!mapData) {
      let t2;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[3] = t2;
      } else {
        t2 = $[3];
      }
      t1 = t2;
      break bb1;
    }
    let t2;
    if ($[4] !== mapData.metadata.subcategories) {
      t2 = mapData.metadata.subcategories.map(_temp);
      $[4] = mapData.metadata.subcategories;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = t2;
  }
  const allSubcategoryIds = t1;
  let t2;
  if ($[6] !== dispatch) {
    t2 = hiddenIds => {
      dispatch(setActiveCategoryId(null));
      dispatch(setFilterStateFromUrl({
        hiddenSubcategories: hiddenIds,
        hideAll: false,
        teleportOnly: false,
        unfoundOnly: false,
        searchTerm: ""
      }));
    };
    $[6] = dispatch;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const dispatchChecklistFilter = t2;
  let t3;
  if ($[8] !== allSubcategoryIds || $[9] !== checklistSubcategoryIds || $[10] !== dispatchChecklistFilter) {
    t3 = () => {
      const hiddenIds_0 = allSubcategoryIds.filter(id => !checklistSubcategoryIds.has(id));
      dispatchChecklistFilter(hiddenIds_0);
    };
    $[8] = allSubcategoryIds;
    $[9] = checklistSubcategoryIds;
    $[10] = dispatchChecklistFilter;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const showChecklistCategories = t3;
  let t4;
  if ($[12] !== allSubcategoryIds || $[13] !== dispatchChecklistFilter) {
    t4 = subcategoryId => {
      const hiddenIds_1 = allSubcategoryIds.filter(id_0 => id_0 !== subcategoryId);
      dispatchChecklistFilter(hiddenIds_1);
    };
    $[12] = allSubcategoryIds;
    $[13] = dispatchChecklistFilter;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const showSingleSubcategory = t4;
  let t5;
  if ($[15] !== analytics || $[16] !== currentMapInfo?.name || $[17] !== externalMapId || $[18] !== filters || $[19] !== hostType || $[20] !== mapData || $[21] !== showChecklistCategories || $[22] !== titleName) {
    t5 = () => {
      if (!mapData) {
        return;
      }
      savedFiltersRef.current = structuredClone(filters);
      showChecklistCategories();
      analytics.event("game_map_checklist_open", {
        mapId: externalMapId,
        mapName: currentMapInfo?.name,
        titleName,
        platform: hostType
      });
    };
    $[15] = analytics;
    $[16] = currentMapInfo?.name;
    $[17] = externalMapId;
    $[18] = filters;
    $[19] = hostType;
    $[20] = mapData;
    $[21] = showChecklistCategories;
    $[22] = titleName;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  currentMapInfo?.name;
  const enterChecklist = t5;
  let t6;
  if ($[24] !== dispatch) {
    t6 = () => {
      if (savedFiltersRef.current) {
        dispatch(setFilterStateFromUrl(savedFiltersRef.current));
        savedFiltersRef.current = null;
      }
    };
    $[24] = dispatch;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  const exitChecklist = t6;
  let t7;
  if ($[26] !== enterChecklist || $[27] !== exitChecklist || $[28] !== showChecklistCategories || $[29] !== showSingleSubcategory) {
    t7 = {
      enterChecklist,
      exitChecklist,
      showChecklistCategories,
      showSingleSubcategory
    };
    $[26] = enterChecklist;
    $[27] = exitChecklist;
    $[28] = showChecklistCategories;
    $[29] = showSingleSubcategory;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  return t7;
}
function _temp(sub_0) {
  return sub_0.externalId;
}